class StoreService {
  constructor (
    id = undefined,
    creatorId,
    dataId,
    startedAt,
    finishedAt,
    missionIds
  ) {
    this.id = id
    this.creatorId = creatorId
    this.creator = null
    this.dataId = dataId
    this.data = null
    this.startedAt = startedAt && new Date(startedAt)
    this.finishedAt = finishedAt && new Date(finishedAt)
    this.missionIds = missionIds
    this.missions = null
    this.forceClose = null
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      // creatorId is read-only
      // dataId is read-only
      // startedAt is read-only
      // finishedAt is read-only
      // missionIds is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    creatorId,
    dataId,
    startedAt,
    finishedAt,
    missionIds,
    forceClose
  }) {
    const service = new StoreService(
      id,
      creatorId,
      dataId,
      startedAt,
      finishedAt,
      missionIds
    )
    if (forceClose) {
      service.forceClose = {
        ...forceClose,
        performedAt: forceClose.performedAt && new Date(forceClose.performedAt)
      }
    }
    return service
  }

  static creatorToGridJSON (creator) {
    if (!creator) {
      return null
    }
    return {
      id: creator.id,
      firstName: creator.firstName,
      lastName: creator.lastName,
      photo: creator.photo?.path ? { path: creator.photo.path } : null
    }
  }

  toJSON () {
    return {
      id: this.id,
      creatorId: this.creatorId,
      creator: StoreService.creatorToGridJSON(this.creator),
      dataId: this.dataId,
      startedAt: this.startedAt,
      finishedAt: this.finishedAt,
      missionIds: this.missionIds,
      forceClose: this.forceClose
    }
  }

  static FromJSON ({
    id,
    creatorId,
    dataId,
    startedAt,
    finishedAt,
    missionIds,
    forceClose
  }) {
    const service = new StoreService(
      id,
      creatorId,
      dataId,
      startedAt,
      finishedAt,
      missionIds
    )
    if (forceClose) {
      service.forceClose = {
        ...forceClose,
        performedAt: forceClose.performedAt && new Date(forceClose.performedAt)
      }
    }
    return service
  }
}

export default StoreService
